import { useQuery, useQueryClient } from "@tanstack/react-query";
import { Tent, Check, X } from "lucide-react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

const Row = ({ r, kind, onDecide }) => (
  <div className="eyw-card p-4 flex flex-wrap items-center gap-3" data-testid={`mgr-space-${kind}-${r.id}`}>
    <div className="flex-1 min-w-0">
      <p className="text-sm font-semibold text-[#1A242B]">{r.title}</p>
      <p className="text-xs text-[#4A5D6B]">{r.enhancer_name || "Enhancer"} · {kind === "hold" ? r.room_name : r.location} · {r.date} {r.start_time}–{r.end_time}{r.series_id ? " · repeating" : ""}</p>
    </div>
    <button onClick={() => onDecide(kind, r.id, "approve")} className="eyw-btn !py-1.5 !px-3 text-xs" data-testid={`mgr-space-approve-${r.id}`}><Check size={13} /> Approve</button>
    <button onClick={() => onDecide(kind, r.id, "reject")} className="eyw-btn-ghost !py-1.5 !px-3 text-xs" data-testid={`mgr-space-reject-${r.id}`}><X size={13} /> Decline</button>
  </div>
);

// Enhancer requests for this center's group & retreat spaces (center managers approve these).
export const SpaceRequestsSection = () => {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["mgr-venue-pending"], queryFn: () => api.get("/manager/venue/pending").then((r) => r.data) });
  const holds = data?.holds || [], retreats = data?.retreats || [];
  const decide = async (kind, id, action) => {
    try {
      await api.put(`/manager/venue/${kind === "hold" ? "holds" : "retreats"}/${id}`, { action });
      toast.success(action === "approve" ? "Approved — it's on the calendar" : "Request declined");
      qc.invalidateQueries({ queryKey: ["mgr-venue-pending"] });
      qc.invalidateQueries({ queryKey: ["mgr-dash"] });
    } catch (e) { const d = e.response?.data?.detail; toast.error(typeof d === "object" ? d.message : formatApiError(d)); }
  };
  return (
    <div className="mb-8" data-testid="mgr-space-requests">
      <h3 className="font-serif text-xl text-[#1A242B] mb-1 flex items-center gap-2"><Tent size={17} /> Space requests</h3>
      <p className="text-xs text-[#4A5D6B] mb-3">Enhancers asking to use your group and retreat spaces. Healing and wellness rooms book instantly.</p>
      {!holds.length && !retreats.length ? <p className="text-sm text-[#8FA89B]" data-testid="mgr-space-requests-empty">No space requests waiting.</p> : (
        <div className="space-y-2">
          {holds.map((r) => <Row key={r.id} r={r} kind="hold" onDecide={decide} />)}
          {retreats.map((r) => <Row key={r.id} r={r} kind="retreat" onDecide={decide} />)}
        </div>
      )}
    </div>
  );
};
